export default () => jQuery(($) => {
    $('.commentReply > a').on('click', function(e) {
       e.preventDefault();

       var comment_id = $(this).attr('class');
       $('input#comment_parent').val(comment_id);

       $('html, body').animate({
           scrollTop: $('.addCommentForm').offset().top
       }, 1000, function() {
           $('input#comment-author').focus();
       });
    });
});